/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSlashes = createReactComponent("outline", "slashes", "IconSlashes", [["path", { "d": "M14 5l-10 14", "key": "svg-0" }], ["path", { "d": "M20 5l-10 14", "key": "svg-1" }]]);

export { IconSlashes as default };
//# sourceMappingURL=IconSlashes.mjs.map
